/**
 * Task (API)
 *  タスク関連のAPI
 */
import session from './session'

var uri = process.env.API_ENDPOINT

export default {
  // タスクAPI
  createUserTask(data) {
    return session.post(uri + '/api/tk/user_task/', data)
  },
  getUserTask (id) {
    if (id) return session.get(uri + '/api/tk/user_task/' + id)
    else return session.get(uri + '/api/tk/user_task/')
  },
  updateUserTask (data) {
    return session.patch(uri + '/api/tk/user_task/' + data.pk, data)
  },
  deleteUserTask (id) {
    return session.delete(uri + '/api/tk/user_task/' + id)
  },
  // タスクFileAPI
  createUserTaskFile(data) {
    return session.post(uri + '/api/tk/user_task_file/', data)
  },
  updateUserTaskFile (data) {
    return session.patch(uri + '/api/tk/user_task_file/', data)
  },
  deleteUserTaskFile (id) {
    return session.delete(uri + '/api/tk/user_task_file/' + id)
  },
  // タスクlogAPI
  createUserTaskLog(data) {
    return session.post(uri + '/api/tk/user_task_log/', data)
  },
  updateUserTaskLog (data) {
    return session.patch(uri + '/api/tk/user_task_log/' + data.id, data)
  },
  createLinkTrelloAPI (data) {
    return session.post(uri + '/api/tk/link_trello_api/', data)
  },
  createLinkTrelloBoard (data) {
    return session.post(uri + '/api/tk/link_trello_board/', data)
  },
  getTrelloList () {
    return session.get(uri + '/api/tk/trello_list/')
  },
  getTrelloBoard () {
    return session.get(uri + '/api/tk/trello_board/')
  },
}



// WEBPACK FOOTER //
// ./src/api/task.js